import { Box, IconButton, Menu, MenuItem, Typography } from "@mui/material"
import { useState } from "react"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"

const RoleEditMenu = (props: any) => {
  const { handleRoleEditOpen, handleRoleDeleteOpen, setDeleteRoleId, setEditState, currentSeleted } =
    props

  const [anchorEl, setAnchorEl] = useState<any>(null)
  const openMenu = Boolean(anchorEl)

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleClickEdit = () => {
    setEditState({
      id: currentSeleted?.role_id || "",
      title: currentSeleted?.role_display_name || "",
      description: currentSeleted?.role_description || "",
      category: currentSeleted?.role_category || "",
    });
    handleRoleEditOpen(true)
    handleClose()
  }

  const handleClickDelete = () => {
    handleRoleDeleteOpen(true)
    setDeleteRoleId(currentSeleted?.role_id)
    handleClose()
  }

  return (
    <Box>
      <IconButton
        id="basic-button"
        aria-controls={openMenu ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={openMenu ? "true" : undefined}
        onClick={handleClick}
        sx={{
          display: "flex",
          height: "100%",
          alignItems: "center",
          color: "#000000",
        }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "space-around",
            padding: "5px 0",
          }}
          onClick={() => handleClickEdit()}
        >
          <EditIcon sx={{ cursor: "pointer" }} />
          <Typography>Edit</Typography>
        </MenuItem>
        <MenuItem
          sx={{
            display: "flex",
            width: "100px",
            justifyContent: "space-around",
            padding: "5px 0",
          }}
          onClick={() => handleClickDelete()}
        >
          <DeleteIcon sx={{ cursor: "pointer" }} />
          Delete
        </MenuItem>
      </Menu>
    </Box>
  )
}

export default RoleEditMenu
